var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { DisposableGroup } from '@blocksuite/global/utils';
import { WithDisposable } from '@blocksuite/lit';
import { baseTheme } from '@toeverything/theme';
import { css, html, LitElement, unsafeCSS } from 'lit';
import { property } from 'lit/decorators.js';
import { TOCNoteCard } from './toc-card.js';
import { TOCPanelBody } from './toc-panel-body.js';
import { TOCPanelHeader } from './toc-panel-header.js';
import { TOCBlockPreview } from './toc-preview.js';
import { TOCNotesSettingMenu } from './toc-setting-menu.js';
export class TOCPanel extends WithDisposable(LitElement) {
    constructor() {
        super(...arguments);
        this.hidePreviewIcon = false;
        this._toggleHidePreviewIcon = (on) => {
            this.hidePreviewIcon = on;
        };
        this._editorDisposables = null;
    }
    get page() {
        return this.editor.page;
    }
    get host() {
        return this.editor.root;
    }
    get edgeless() {
        return this.editor.querySelector('affine-edgeless-page');
    }
    get mode() {
        return this.editor.mode;
    }
    _clearEditorDisposables() {
        this._editorDisposables?.dispose();
        this._editorDisposables = null;
    }
    _setEditorDisposables() {
        this._clearEditorDisposables();
        this._editorDisposables = new DisposableGroup();
        this._editorDisposables.add(this.editor.slots.pageModeSwitched.on(() => {
            this.editor.updateComplete
                .then(() => {
                this.requestUpdate();
            })
                .catch(console.error);
        }));
        this._editorDisposables.add(this.editor.slots.pageUpdated.on(() => {
            this.editor.updateComplete
                .then(() => {
                this.requestUpdate();
            })
                .catch(console.error);
        }));
    }
    updated(_changedProperties) {
        if (_changedProperties.has('editor')) {
            this._setEditorDisposables();
        }
    }
    connectedCallback() {
        super.connectedCallback();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this._clearEditorDisposables();
    }
    render() {
        return html `
      <div class="toc-panel-container">
        <toc-panel-header
          .hidePreviewIcon=${this.hidePreviewIcon}
          .toggleHidePreviewIcon=${this._toggleHidePreviewIcon}
        ></toc-panel-header>
        <toc-panel-body
          class="toc-panel-body"
          .page=${this.page}
          .fitPadding=${this.fitPadding}
          .edgeless=${this.edgeless}
          .hidePreviewIcon=${this.hidePreviewIcon}
          .editorHost=${this.host}
          .mode=${this.mode}
        >
        </toc-panel-body>
      </div>
    `;
    }
}
TOCPanel.styles = css `
    :host {
      display: block;
      width: 100%;
      height: 100%;
    }

    .toc-panel-container {
      background-color: var(--affine-background-primary-color);
      box-sizing: border-box;

      display: flex;
      flex-direction: column;
      align-items: stretch;

      height: 100%;
      font-family: ${unsafeCSS(baseTheme.fontSansFamily)};
      padding-top: 8px;
    }

    .toc-panel-body {
      flex-grow: 1;
      width: 100%;

      overflow-y: scroll;
    }
  `;
__decorate([
    property({ attribute: false })
], TOCPanel.prototype, "editor", void 0);
__decorate([
    property({ attribute: false })
], TOCPanel.prototype, "hidePreviewIcon", void 0);
__decorate([
    property({ attribute: false })
], TOCPanel.prototype, "fitPadding", void 0);
const componentsMap = {
    'toc-note-card': TOCNoteCard,
    'toc-block-preview': TOCBlockPreview,
    'toc-panel': TOCPanel,
    'toc-notes-setting-menu': TOCNotesSettingMenu,
    'toc-panel-body': TOCPanelBody,
    'toc-panel-header': TOCPanelHeader,
};
export function registerTOCPanelComponents(callback) {
    callback(componentsMap);
}
//# sourceMappingURL=toc-panel.js.map